<template>
  <v-dialog :value="value" persistent max-width="440px">
    <v-card>
      <v-card-title class="mainfont" style="font-size: 18px; font-weight: 700">
        Save your changes?
      </v-card-title>
      <v-card-text class="mainfont" style="color: #475569">
        You have unsaved changes on this application. Do you want to save them as a draft before leaving?
      </v-card-text>
      <v-card-actions class="px-6 pb-5 flex-wrap" style="gap: 8px">
        <v-btn depressed class="btn-act btn-act--neutral" @click="$emit('stay')">Stay on page</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed class="btn-act btn-act--danger" @click="$emit('discard')">Don't save</v-btn>
        <v-btn depressed class="btn-act btn-act--primary" @click="$emit('save')">Save draft</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DraftLeaveDialog",
  props: { value: { type: Boolean, default: false } },
};
</script>
